<template>
  <v-container fluid>
    <v-row class="mb-0">
      <v-col>
        <h1>Предыдущие обращения</h1>
      </v-col>
    </v-row>
    <patient-header />
    <calls-list />
  </v-container>
</template>

<script>
import CallsList from "./components/CallsList";

import PatientHeader from "@/components/PatientHeader";
export default {
  components: {
    CallsList,
    PatientHeader,
  },
};
</script>

<style></style>
